// Vertical Lakes Dash layouts
import Dashboard from "layouts/dashboard";
import Suppliers from "layouts/suppliers";
import Services from "layouts/services";
import Clients from "layouts/clients";
import Products from "layouts/products";
import Complaints from "layouts/complaints";
import Orders from "layouts/orders";
import Transactions from "layouts/transactions";
import TopPerformers from "layouts/top-performers";
// import Tables from "layouts/tables";
// import Billing from "layouts/billing";
// import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import UserProfile from "layouts/user-profile";
import UserManagement from "layouts/user-management";
import UserManagementDetails from "layouts/user-management-details";
import ClientManagementDetails from "layouts/client-management-details";
import ProductManagementDetails from "layouts/product-management-details";
import ProductPerServiceManagementDetails from "layouts/product-per-service-management-details";
import SupplierManagementDetails from "layouts/supplier-management-details";
import OrderManagementDetails from "layouts/order-management-details";
import ComplaintManagementDetails from "layouts/complaint-management-details";
import TransactionManagementDetails from "layouts/transaction-management-details";

import Login from "auth/login";
// import Register from "auth/register";
import ForgotPassword from "auth/forgot-password";
import ResetPassword from "auth/reset-password";

import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "inactive",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "inactive",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "auth",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/auth/login",
    component: <Login />,
  },
  // {
  //   type: "auth",
  //   name: "Register",
  //   key: "register",
  //   icon: <Icon fontSize="small">reigster</Icon>,
  //   route: "/auth/register",
  //   component: <Register />,
  // },
  {
    type: "auth",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/auth/forgot-password",
    component: <ForgotPassword />,
  },
  {
    type: "auth",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/auth/reset-password",
    component: <ResetPassword />,
  },
  {
    type: "examples",
    name: "User Profile",
    key: "user-profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/user-profile",
    component: <UserProfile />,
  },
  {
    type: "examples",
    name: "User Management",
    key: "user-management",
    icon: <Icon fontSize="small">supervisor_account</Icon>,
    route: "/user-management",
    component: <UserManagement />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Suppliers",
    key: "suppliers",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/suppliers",
    component: <Suppliers />,
  },
  {
    type: "collapse",
    name: "Services",
    key: "services",
    icon: <Icon fontSize="small">handyman</Icon>,
    route: "/services",
    component: <Services />,
  },
  {
    type: "collapse",
    name: "Clients",
    key: "clients",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/clients",
    component: <Clients />,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/products",
    component: <Products />,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    icon: <Icon fontSize="small">reorder</Icon>,
    route: "/orders",
    component: <Orders />,
  },
  {
    type: "collapse",
    name: "Transactions",
    key: "transactions",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/transactions",
    component: <Transactions />,
  },
  {
    type: "collapse",
    name: "Complaints",
    key: "complaints",
    icon: <Icon fontSize="small">approval</Icon>,
    route: "/complaints",
    component: <Complaints />,
  },
  {
    type: "divider",
  },
  {
    type: "collapse",
    name: "Top Performers",
    key: "topPerformers",
    icon: <Icon fontSize="small">stars</Icon>,
    route: "/top-performers",
    component: <TopPerformers />,
  },
  {
    type: "details",
    name: "User Management Details",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/user-management/:id",
    component: <UserManagementDetails />,
  },
  {
    type: "details",
    name: "Client Management Details",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/clients/:id",
    component: <ClientManagementDetails />,
  },
  {
    type: "details",
    name: "Product Management Details",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/products/:id",
    component: <ProductManagementDetails />,
  },
  {
    type: "details",
    name: "Product Per Service Management Details",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/products/service/:id",
    component: <ProductPerServiceManagementDetails />,
  },
  {
    type: "details",
    name: "Supplier Management Details",
    key: "profile",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/suppliers/:id",
    component: <SupplierManagementDetails />,
  },
  {
    type: "details",
    name: "Order Management Details",
    key: "profile",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/orders/:id",
    component: <OrderManagementDetails />,
  },
  {
    type: "details",
    name: "Complaint Management Details",
    key: "profile",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/complaints/:id",
    component: <ComplaintManagementDetails />,
  },
  {
    type: "details",
    name: "Transactions Management Details",
    key: "profile",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/transactions/:id",
    component: <TransactionManagementDetails />,
  },
  {
    type: "inactive",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
  // {
  //   type: "inactive",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "inactive",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "inactive",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
];

export default routes;
